import {
  PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getSortedRowModel, SortingState, useReactTable,
} from "@tanstack/react-table";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useState } from "react";
import Pagination from "components/pagination";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { PayoutRowObj } from "..";
import moment from "moment";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import Searchbox from "components/fields/Searchbox";
import StatusRender from "views/admin/payments/components/StatusRender";
import InfoModal from "./infoModal";
import CustomToolTip from "components/tooltips/new";
import { getImage } from "utils/commonFunction";
import Card from "components/card";
import { CP_TABLE_STYLES } from "./PaymentsList";
import AddBatchFile from "./AddBatchFile";
import { getAllClients } from "api/clients";
import toast from "react-hot-toast";
import FilterModalBatch from "./FilterModalBatch";

const columnHelper = createColumnHelper<PayoutRowObj>();

function PayoutList(props: {
  tableData: any; fetchPayouts: () => void; onValueChange: (value: string) => void;
  roleData?: any; isLoading: boolean; page: number; setPage: any;
  totalpage: number; totalItems: number; currentPage: number;
  pageSize: number; setPageSize: any; filterData: () => void;
  batchfilter: any; setBatchFilter: (e: any) => void;
  setLocalFilters?: (e: any) => void; setClearClick: () => void; localFilters?: any;allOrgDetails:any
}) {
  const { tableData, onValueChange, isLoading, roleData, page, setPage, totalpage, currentPage,setClearClick, pageSize, setPageSize, fetchPayouts,totalItems,batchfilter,setBatchFilter,allOrgDetails,filterData } = props;

  const [{ pageIndex }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize });
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [data, setData] = React.useState(() => [...(tableData ?? [])]);
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);
  const [subClientsData, setSubClientsData] = useState([]);
  React.useEffect(() => { setExpandedRow(null); }, [page, pageSize]);
  useEffect(() => { setData(tableData?.map((item: any) => ({ ...item })) ?? []); }, [tableData]);

  const handleExpand = (rowId: any) => setExpandedRow(expandedRow === rowId ? null : rowId);
  const approveBatch = (_id: any) => {};

  const buildCols = (withAction: boolean) => [
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => <span className="cp-th">Created Date</span>,
      cell: (info: any) => (
        <button className="cp-expand-cell" onClick={() => handleExpand(info?.row?.original?.id)}>
          {expandedRow === info?.row?.original?.id
            ? <AiFillMinusCircle className="cp-expand-icon cp-expand-icon--minus" />
            : <AiFillPlusCircle className="cp-expand-icon cp-expand-icon--plus" />}
          <span className="cp-date">{moment(info.getValue()).format("YYYY-MM-DD HH:mm:ss")}</span>
        </button>
      ),
    }),
    columnHelper.accessor("batchId", {
      id: "batchId",
      header: () => <span className="cp-th">Batch ID</span>,
      cell: (info) => <ShortTruncateCopy info={info?.getValue()} showCopy />,
    }),
    columnHelper.accessor("clientName", {
      id: "clientName",
      header: () => <span className="cp-th">Client</span>,
      cell: (info) => (
        <div className="cp-client-cell">
          <div className="cp-client-avatar">{info.getValue()?.charAt(0)?.toUpperCase() || "?"}</div>
          <span className="cp-client-name">{info.getValue()}</span>
        </div>
      ),
    }),
    columnHelper.accessor("totalTransactions", {
      id: "totalTransactions",
      header: () => <span className="cp-th">TX #</span>,
      cell: (info: any) => <span className="cp-num">{info.getValue()}</span>,
    }),
    columnHelper.accessor("gatewayName", {
      id: "gatewayName",
      header: () => <span className="cp-th">Gateway {roleData[0]?.crypto?.value?.show_crypto_payout_gateway_name ? "Name" : "Hash ID"}</span>,
      cell: (info: any) => (
        !roleData[0]?.crypto?.value?.show_crypto_payout_gateway_name
          ? <ShortTruncateCopy info={info?.row?.original?.gatewayId || "—"} showCopy />
          : <div className="cp-gateway-cell">
              <img style={{ height:"auto", width:"14px" }} src={getImage(info.getValue())} alt="" />
              <span className="cp-gateway-name">{info.getValue() || "—"}</span>
            </div>
      ),
    }),
    columnHelper.accessor("totalAmount", {
      id: "totalAmount",
      header: () => <span className="cp-th">Batch Total</span>,
      cell: (info: any) => <span className="cp-amount">{Number(info.getValue() ?? 0).toFixed(4)}</span>,
    }),
    columnHelper.accessor("type", {
      id: "type",
      header: () => <span className="cp-th">Type</span>,
      cell: (info: any) => <span className="cp-type-tag">{String(info.getValue()).replace('-'," ")}</span>,
    }),
    ...(withAction ? [columnHelper.accessor("id", {
      id: "action",
      header: () => <span className="cp-th">Actions</span>,
      cell: (info: any) => (
        <div className="cp-actions">
          {roleData?.[0]?.crypto?.value?.approve_batch_file && info?.row?.original?.type === 'require-approve'
            ? <button className="cp-approve-btn" onClick={() => approveBatch(info?.row?.original?.id)}>Approve</button>
            : <span className="cp-muted">—</span>}
        </div>
      ),
      enableSorting: false,
    })] : []),
  ];

  const columns = buildCols(true);
  const columnsNonAction = buildCols(false);

  const table = useReactTable({
    data,
    columns: roleData?.[0]?.crypto?.value?.approve_batch_file ? columns : columnsNonAction,
    state: { pagination, sorting },
    onPaginationChange: setPagination, onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(), getSortedRowModel: getSortedRowModel(),
  });

  const getSubClientsData = () => {
      getAllClients(0)
      .then((data) => setSubClientsData(data[0]))
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching clients"))
      .finally(() => {  });
  };
    
  React.useEffect(() => { getSubClientsData(); }, []);

  const resetRow = () => {
    setExpandedRow(null);
  }

  const findLastErrorMessage = (obj: any): string | null => {
    const errorKeys = ["errorMessage","message","decline_reason","error_message","failure_message","failure_code"];
    let lastValue: string | null = null;
    const search = (data: any) => {
      if (!data || typeof data !== "object") return;
      for (const key of Object.keys(data)) {
        if (errorKeys.includes(key) && key !== "_content") lastValue = data[key];
        if (typeof data[key] === "object") search(data[key]);
      }
    };
    search(obj); return lastValue;
  };

  const parsePythonJSON = (str: string): any[] => {
    try {
      return JSON.parse(str.replace(/\bNone\b/g,"null").replace(/\bFalse\b/g,"false").replace(/\bTrue\b/g,"true")
        .replace(/([{,]\s*)'([^']+)'\s*:/g,'$1"$2":').replace(/:\s*'([^']*)'/g,': "$1"'));
    } catch { return []; }
  };

  return (
    <div className="cp-table-card">
      <div className="cp-table-header">
        <div className="cp-table-header-left">
          <div className="cp-table-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
            </svg>
          </div>
          <div>
            <h3 className="cp-table-title">Crypto Payouts</h3>
            {/* <p className="cp-table-sub">Batch crypto payout records</p> */}
            <p className="cp-table-sub">{totalItems > 0 ? `${totalItems.toLocaleString()} total batch${totalItems !== 1 ? "es" : ""}` : "No batches"}</p>

          </div>
        </div>
        <div className="cp-table-header-right">
          <FilterModalBatch
            subClientsData={subClientsData} setPage={props.setPage}
            filter={batchfilter} setFilter={setBatchFilter} roleData={roleData}
            setClearClick={setClearClick} 
            fetchAllsettlement={fetchPayouts}
            allOrgDetails={allOrgDetails}
            filterData={filterData}
            resetRow= {resetRow}
          />
            <AddBatchFile fetchPayouts={fetchPayouts} />
          <Searchbox onSearch={(e) => { setExpandedRow(null); onValueChange(e); }} />
        </div>
      </div>

      <div className="cp-table-wrap">
        {isLoading ? (
          <div className="cp-loading"><div className="cp-spinner" /><p className="cp-loading-txt">Loading batch payouts…</p></div>
        ) : (
          <table className="cp-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id} colSpan={h.colSpan}
                      onClick={h.column.getCanSort() ? h.column.getToggleSortingHandler() : undefined}
                      className={`cp-thead-th${h.column.getCanSort() ? " cp-thead-th--sort" : ""}`}
                    >
                      <div className="cp-th-inner">
                        {flexRender(h.column.columnDef.header, h.getContext())}
                        {h.column.getCanSort() && (
                          <span className="cp-sort-icon">
                            {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11} /> :
                             h.column.getIsSorted() === "desc" ? <BsArrowDown size={11} /> :
                             <RiArrowUpDownFill size={11} />}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <React.Fragment key={row.id}>
                    <tr className={`cp-tbody-tr${ri % 2 !== 0 ? " cp-tbody-tr--alt" : ""}`}>
                      {row.getVisibleCells().map((cell, ci) => (
                        <td key={ci} className="cp-tbody-td">{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                      ))}
                    </tr>

                    {expandedRow === (row.original as any).id && (
                      <tr className="cp-expanded-row">
                        <td colSpan={columns.length} className="cp-expanded-cell">
                          <div className="cp-subtable-wrap">
                            <h4 className="cp-subtable-heading">Transactions</h4>
                            {Object.keys((row.original as any).transactions ?? {}).length > 0 ? (
                              <table className="cp-table">
                                <thead>
                                  <tr>
                                    {["Created At","Customer ID","Quote ID","Amount","Status",
                                      ...(roleData?.[0]?.crypto?.value?.view_crypto_payout_gateway_response_information ? ["Action"] : [])
                                    ].map((h) => (
                                      <th key={h} className="cp-thead-th"><span className="cp-th">{h}</span></th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.entries((row.original as any).transactions).map(([txId, tx]: [string, any]) => (
                                    <tr key={txId} className="cp-tbody-tr">
                                      <td className="cp-tbody-td"><span className="cp-date">{moment(tx.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span></td>
                                      {/* crypto uses payerId (not customerId) */}
                                      <td className="cp-tbody-td"><ShortTruncateCopy info={tx.payerId} showCopy /></td>
                                      <td className="cp-tbody-td"><span className="cp-muted">—</span></td>
                                      <td className="cp-tbody-td"><span className="cp-amount">{Number(tx.amount ?? 0).toFixed(5)} {tx.currency}</span></td>
                                      <td className="cp-tbody-td">
                                        <CustomToolTip
                                          content={(() => {
                                            try {
                                              const hist = Array.isArray(tx.paymentHistory) ? tx.paymentHistory : typeof tx.paymentHistory === "string" ? parsePythonJSON(tx.paymentHistory) : [];
                                              if (!hist.length) return <span>No history available.</span>;
                                              return hist.map((h: any, i: number) => (
                                                <Card className="m-2 shadow" key={i}>
                                                  <div className="border border-white p-3 max-w-[60vh]">
                                                    <p>Created at {h?.created_at} by API call from [{h?.client} - {h?.ip}] with status {h?.status}</p>
                                                  </div>
                                                </Card>
                                              ));
                                            } catch { return <span>Error loading history</span>; }
                                          })()}
                                          trigger={<button className="cp-status-btn"><StatusRender status={tx.status} value={tx.status} /></button>}
                                          header="Status History"
                                        />
                                      </td>
                                      {roleData?.[0]?.crypto?.value?.view_crypto_payout_gateway_response_information && (
                                        <td className="cp-tbody-td"><InfoModal info={tx.gatewayResponse} /></td>
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="cp-subtable-empty">No transactions available.</div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr><td colSpan={10}>
                  <div className="cp-empty">
                    <div className="cp-empty-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/></svg></div>
                    <p className="cp-empty-title">No batch payouts found</p>
                    <p className="cp-empty-sub">Upload a crypto batch file to get started</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      <div className="cp-pagination-wrap">
        <Pagination setPage={setPage} page={page} totalpage={props.totalpage} currentPage={currentPage} pageSize={pageSize} setPageSize={setPageSize} arraySize={[50, 100, 200]} />
      </div>

      {CP_TABLE_STYLES}
      <style>{`
        .cp-expand-cell { display:inline-flex; align-items:center; gap:7px; background:none; border:none; cursor:pointer; padding:0; font-family:'Plus Jakarta Sans',sans-serif; }
        .cp-expand-icon { width:18px; height:18px; flex-shrink:0; }
        .cp-expand-icon--plus  { color:#7c3aed; }
        .cp-expand-icon--minus { color:#dc2626; }
        .cp-num { font-size:12.5px; font-weight:700; color:#0f172a; }
        .cp-type-tag { display:inline-block; padding:3px 9px; border-radius:7px; font-size:11px; font-weight:700; background:#faf5ff; border:1.5px solid #ddd6fe; color:#6d28d9; text-transform:capitalize; white-space:nowrap; }
        .cp-muted { font-size:12px; color:#cbd5e1; }
        .cp-approve-btn { display:inline-flex; align-items:center; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:700; color:#fff; padding:6px 14px; border-radius:8px; border:none; background:linear-gradient(135deg,#6d28d9,#7c3aed); cursor:pointer; transition:all .15s; }
        .cp-approve-btn:hover { transform:translateY(-1px); }
        .cp-expanded-cell { padding:0 !important; border-bottom:2px solid #e2e8f0; }
        .cp-subtable-wrap { background:#f5f0ff; border-left:3px solid #ddd6fe; padding:14px 16px; overflow-x:auto; }
        .cp-subtable-heading { font-size:12px; font-weight:700; color:#3b0764; text-transform:uppercase; letter-spacing:.5px; margin-bottom:12px; }
        .cp-subtable-empty { font-size:13px; color:#64748b; font-weight:500; text-align:center; padding:20px; }
      `}</style>
    </div>
  );
}

export default PayoutList;